import gql from 'graphql-tag';

export const PORTAL_TRANSFERS_QUERY = gql`
query portalCommissions($operatorId: String, $skip: Int, $first: Int, $startDate: String, $endDate: String, $establishmentId: String, $portalUserId: String, $listOperators: String, $status: String) {
  commissionsTransfers(operatorId: $operatorId, first: $first, skip: $skip, startDate: $startDate, endDate: $endDate, establishmentId: $establishmentId, portalUserId: $portalUserId, listOperators: $listOperators, status: $status) {
    count
    sumAll
    sumCommissionsOperators
    sumCommissionsEstablishments
    sumCommissionsPortalusers
    transfers {
      id
      amount
      createdAt
      transfer{
          status
      }
      entity {
        portalUser {
          user {
            name
          }
        }
        operator {
          title
        }
        establishment {
          title
        }
      }
    }
  }
}
`;

export const PORTAL_ESTABLISHMENTS_QUERY = gql`
    query PortalEstablishments($operatorId: String!) {
        portalEstablishments(operatorId: $operatorId) {
            id,
            title,
            address {
                state
            },
        }
    }
`;

export const PORTAL_USERS_QUERY = gql`
    query portalUsers($operatorId: Int!) {
      portalUsers(operatorId: $operatorId) {
        id
        user{
          name
          document
        }
      }
    }
`;

export const PORTAL_REFRESH_TOKEN = gql`
    mutation refreshToken($token: String!) {
      refreshToken(token: $token) {
        token
      }
    }
`;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/graphql.js